import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import { BRAND_LIST, CATEGORY_LIST, HSN_LIST, CREATE_DELETE_BRAND, CREATE_DELETE_CATEGORY, CREATE_DELETE_HSN, GST_LIST, BUSINESS_ITEM_LIST, GET_DROPDOWN_DATA, FETCH_BRAND_HSN, APPROVE_ITEM} from "./type";

export const getBrandList = (filterData, page = 1) => async (dispatch) => {
    dispatch({
        type: BRAND_LIST,
        payload: [],
    });

    let url = `${Config.businessItems.getBrands}?page=${page}`;

    if (filterData !== null) {
        url += `&name=${filterData.name || ''}`;
        url += `&category_id=${filterData.category_id || ''}`;
    }

    const res = await callWebService(callTypes.get, '', url);

    if (res?.data?.response?.status === 200) {
        dispatch({
        type: BRAND_LIST,
        payload: res?.data?.response?.data || {},
        });
    } else {
        return res;
    }
};

export const getCategoryList = (filterData, page = 1, dropdown = false) => async (dispatch) => {
    dispatch({
        type: CATEGORY_LIST,
        payload: [],
    });

    let url = `${Config.businessItems.getCategories}?page=${page}&dropdown=${dropdown}`;

    if (filterData !== null) {
        url += `&name=${filterData.name || ''}`;
    }

    const res = await callWebService(callTypes.get, '', url);

    if (res?.data?.response?.status === 200) {
        dispatch({
        type: CATEGORY_LIST,
        payload: res?.data?.response?.data || {},
        });
    } else {
        return res;
    }
};

export const getHsnList = (filterData, page = 1) => async (dispatch) => {
    dispatch({
        type: HSN_LIST,
        payload: [],
    });

    let url = `${Config.businessItems.getHsnListing}?page=${page}`;

    if (filterData) {
      if (filterData.hsn_code) {
        url += `&hsn_code=${filterData.hsn_code}`;
      }
      if (filterData.gst_code) {
        url += `&gst_code=${filterData.gst_code}`;
      }
    }

    const res = await callWebService(callTypes.get, '', url);

    if (res?.data?.response?.status === 200) {
        dispatch({
        type: HSN_LIST,
        payload: res?.data?.response?.data || {},
        });
    } else {
        return res;
    }
};

export const createDeleteBrand = (data) => async (dispatch) => {

  try {
    const res = await callWebService(
      callTypes.post,
      data,
      Config.businessItems.createDeleteBrand
    );

    if (res?.data) {
      dispatch({
        type: CREATE_DELETE_BRAND,
        payload: res.data.response || {},
      });
    }

    return res || { status_code: 400, message: "Something went wrong" };
  } catch (error) {
    console.error("Error creating brand:", error);
    return { status_code: 400, message: error.message || "Something went wrong" };
  }

};

export const createDeleteHsn = (data) => async (dispatch) => {

  try {
    const res = await callWebService(
      callTypes.post,
      data,
      Config.businessItems.createDeleteHSN
    );

    if (res?.data) {
      dispatch({
        type: CREATE_DELETE_HSN,
        payload: res.data.response || {},
      });
    }

    return res || { status_code: 400, message: "Something went wrong" };
  } catch (error) {
    console.error("Error creating HSN:", error);
    return { status_code: 400, message: error.message || "Something went wrong" };
  }

};

export const getGstList = () => async (dispatch) => {
    dispatch({
        type: GST_LIST,
        payload: [],
    });

    let url = `${Config.businessItems.getGstData}`;

    const res = await callWebService(callTypes.get, '', url);

    if (res?.data?.response?.status === 200) {
        dispatch({
        type: GST_LIST,
        payload: res?.data?.response?.data || {},
        });
    } else {
        return res;
    }
};

export const createDeleteCategory = (data) => async (dispatch) => {
  try {
    const res = await callWebService(
      callTypes.post,
      data,
      Config.businessItems.createDeleteCategory
    );

    if (res?.data) {
      dispatch({
        type: CREATE_DELETE_CATEGORY,
        payload: res.data.response || {},
      });
    }

    return res || { status_code: 400, message: "Something went wrong" };
  } catch (error) {
    console.error("Error creating category:", error);
    return { status_code: 400, message: error.message || "Something went wrong" };
  }
};

export const getBusinessItemList = (filterData, type, page = 1, id = null, edit = null) => async (dispatch) => {
  dispatch({
    type: BUSINESS_ITEM_LIST,
    payload: [],
  });

  let url = `${Config.businessItems.getBusinessItemListing}?page=${page}&type=${type}`;

  if (filterData) {
    if (filterData.name) {
      url += `&name=${filterData.name}`;
    }
    if (filterData.code) {
      url += `&code=${filterData.code}`;
    }
  }

  if (id) {
    url += `&id=${id}`;
  }

  if (edit) {
    url += `&edit=${edit}`;
  }

  const res = await callWebService(callTypes.get, '', url);

  if (res?.data?.response?.status === 200) {
    dispatch({
      type: BUSINESS_ITEM_LIST,
      payload: res?.data?.response?.data || {},
    });
    return res?.data?.response?.data;
  } else {
    return res;
  }
};

export const getDropdownData = () => async (dispatch) => {
  dispatch({
    type: GET_DROPDOWN_DATA,
    payload: [],
  });

  let url = `${Config.businessItems.getItemDropdownData}`;

  const res = await callWebService(callTypes.get, '', url);

  if (res?.data?.response?.status === 200) {
    dispatch({
      type: GET_DROPDOWN_DATA,
      payload: res?.data?.response?.data || {},
    });
  } else {
    return res;
  }
};

export const approveItemRequest = (data) => async (dispatch) => {

  try {
    const res = await callWebService(
      callTypes.post,
      data,
      Config.businessItems.approveItem
    );

    if (res?.data) {
      dispatch({
        type: APPROVE_ITEM,
        payload: res.data.response || {},
      });
    }

    return res || { status_code: 400, message: "Something went wrong" };
  } catch (error) {
    console.error("Error in approving item:", error);
    return { status_code: 400, message: error.message || "Something went wrong" };
  }

};

export const fetchBrandAndHsn = (type, gst_id = null, category_id = null) => async (dispatch) => {
  let url = `${Config.businessItems.fetchBrandAndHsn}?type=${type}`;

  if (gst_id) url += `&gst_id=${gst_id}`;
  if (category_id) url += `&category_id=${category_id}`;

  const res = await callWebService(callTypes.get, '', url);

  if (res?.data?.status === 200) {
    dispatch({
      type: "FETCH_BRAND_HSN",
      payload: res?.data || {},
    });
  } else {
    dispatch({
      type: "FETCH_BRAND_HSN",
      payload: {},
    });
  }
};


export const createItemRequest = (data) => async (dispatch) => {
  try {
    const res = await callWebService(
      callTypes.post,
      data,
      Config.businessItems.createMaterials
    );

    return res || { status_code: 400, message: "Something went wrong" };
  } catch (error) {
    console.error("Error in creating item:", error);
    return { status_code: 400, message: error.message || "Something went wrong" };
  }
};

export const updateItemRequest = (data) => async (dispatch) => {
  try {
    const res = await callWebService(
      callTypes.post,
      data,
      Config.businessItems.editMaterials
    );

    return res || { status_code: 400, message: "Something went wrong" };
  } catch (error) {
    console.error("Error in updating item:", error);
    return { status_code: 400, message: error.message || "Something went wrong" };
  }
};
